export default "/images/vendor/flag-icons/flags/4x3/eu.svg?c9d8d63e107e62b812c8cb4eaffb5da5";